import { queryOptions } from '@tanstack/react-query';

import { api } from '@/lib/api/api';
import type { InvoiceListParams } from '@/lib/api/domains/invoices';
import type { InvoiceId } from '@/lib/api/ids';
import { keys } from '@/lib/query-keys';

/*
 * Consumption layer (spec §3.1). Transport says what endpoints exist; these
 * queryOptions say how this UI consumes them — keys, stale times, select.
 * Short stale times on financial data (spec §7.3).
 */

export function invoiceListQuery(params: InvoiceListParams) {
  return queryOptions({
    queryKey: keys.invoices.list(params),
    queryFn: () => api.invoices.list(params),
    staleTime: 15_000,
  });
}

export function invoiceDetailQuery(invoiceId: InvoiceId) {
  return queryOptions({
    queryKey: keys.invoices.detail(invoiceId),
    queryFn: () => api.invoices.get(invoiceId),
    staleTime: 15_000,
  });
}

export function invoiceEventsQuery(invoiceId: InvoiceId) {
  // Seam: `api.invoices.events(invoiceId, cursor?)` supports a `cursor` for a
  // paginated timeline, but this query fetches only the first page — the current
  // UI shows a bounded recent-events list, so no pagination is wired. To paginate,
  // thread `cursor` into both the queryKey (keys.invoices.events(invoiceId, cursor))
  // and the queryFn, and switch to infiniteQueryOptions at the call site.
  return queryOptions({
    queryKey: keys.invoices.events(invoiceId),
    queryFn: () => api.invoices.events(invoiceId),
    staleTime: 15_000,
  });
}
